import { useQuery } from "@tanstack/react-query";
import { WhatsNewEntry } from "../../core/models/entities/WhatsNewEntry";
import { Resource } from "../../core/models/wrappers/Resource";
import { useApiClient } from "../clients/ApiClient";
import { mapToWhatsNewEntry } from "../models/mappers/mapWhatsNewEntry";

export interface ContentRepository {
  // Fail-silent: any API error resolves to an empty list (the header button
  // hides itself) - the changelog must never break the app shell. Entries
  // keep the API's newest-first order.
  useWhatsNew(): Resource<WhatsNewEntry[]>;
}

export function useContentRepository(): ContentRepository {
  const apiClient = useApiClient();

  function useWhatsNew(): Resource<WhatsNewEntry[]> {
    return useQuery(
      ["whats-new"],
      () =>
        apiClient
          .getWhatsNew()
          .then((response) => response.entries.map(mapToWhatsNewEntry))
          // Errors resolve as success-with-empty so React Query does not
          // retry-hammer a broken endpoint on every header render.
          .catch(() => [] as WhatsNewEntry[]),
      {
        // No polling beyond React Query's staleness: at most one fetch per
        // 30 minutes, and only when a component actually mounts the hook.
        staleTime: 30 * 60 * 1000,
      },
    );
  }

  return { useWhatsNew };
}
